export const getSelectedCount = (totalCount, selected) => {
  const selectedMembers = selected;

  if (selectedMembers.all) {
    return totalCount - Object.keys(selectedMembers.exclude).length;
  }

  return Object.keys(selectedMembers.include).length;
};

export const getAreAllSelected = (totalCount, selected) => {
  const allMembersCount = totalCount;
  const selectedMembers = selected;

  const areAllSelected =
    selectedMembers.all && Object.keys(selectedMembers.exclude).length === 0;
  const manualAll =
    !selectedMembers.all &&
    Object.keys(selectedMembers.include).length === allMembersCount;

  return (areAllSelected || manualAll) && totalCount > 0;
};

export const getAreSomeSelected = (totalCount, selected) => {
  const allMembersCount = totalCount;
  const selectedMembers = selected;
  const includedMembersLength = Object.keys(selectedMembers.include).length;
  const excludedMembersLength = Object.keys(selectedMembers.exclude).length;

  const someIncluded =
    includedMembersLength > 0 && includedMembersLength < allMembersCount;
  const someExcluded =
    excludedMembersLength > 0 && excludedMembersLength < allMembersCount;

  return someIncluded || someExcluded;
};

export const getAreAllSelectedOnThePage = (idsOnThePage, selected) => {
  return !idsOnThePage.some(
    id => !selected.include[id] || selected.exclude[id]
  );
};

export const getAreSomeSelectedOnThePage = (idsOnThePage, selected) => {
  return idsOnThePage.some(id => selected.include[id] && !selected.exclude[id]);
};

export const select = (id, selectedMembers) => {
  const selected = {
    ...selectedMembers,
    exclude: { ...selectedMembers.exclude },
    include: { ...selectedMembers.include },
  };

  if (selected.all) {
    if (selected.exclude[id]) {
      delete selected.exclude[id];
    } else {
      selected.exclude[id] = true;
    }
  } else {
    if (selected.include[id]) {
      delete selected.include[id];
    } else {
      delete selected.exclude[id];
      selected.include[id] = true;
    }
  }
  return selected;
};

export const isSelected = (selected, id) => {
  return !selected.exclude[id] && (selected.include[id] || selected.all);
};

export const toggleSelection = (selected, payload) => {
  const { all, allOnPage, ids, id, onlyIfSelected } = payload;
  if (all) {
    return {
      all: !selected.all,
      include: {},
      exclude: {},
    };
  }

  let next = { ...selected };
  if (allOnPage && ids) {
    const allSelectedOnPage = getAreAllSelectedOnThePage(ids, next);
    const someSelectedOnPage = getAreSomeSelectedOnThePage(ids, next);
    const anySelectedOnPage = someSelectedOnPage || allSelectedOnPage;
    const shouldSelect =
      (!selected.selectAll || !anySelectedOnPage) && !allSelectedOnPage;
    next = ids.reduce((acc, current) => {
      const itemSelected = isSelected(next, current);
      if (shouldSelect && !itemSelected) {
        return select(current, acc);
      }

      if (!shouldSelect && itemSelected) {
        return select(current, acc);
      }

      return acc;
    }, next);

    next.selectAll = shouldSelect;
    return next;
  }

  if (ids) {
    return ids.reduce(
      (acc, current) =>
        !onlyIfSelected || isSelected(next, current)
          ? select(current, acc)
          : acc,
      next
    );
  }

  if (id) {
    return !onlyIfSelected || isSelected(next, id) ? select(id, next) : next;
  }

  return next;
};
